import { QueuedOpKind } from './offline-queue.types';

/**
 * A human label for each queued-op kind — used only by the dropped-ops
 * surface (prod-readiness 4.7), so a waiter sees "Add item" rather than the
 * raw callable name "addOrderLine".
 */
export const QUEUED_OP_KIND_LABEL: Record<QueuedOpKind, string> = {
  createStaffOrder: 'New order',
  addOrderLine: 'Add item',
  voidOrderLine: 'Remove item',
  markOrderServed: 'Mark order served',
  markOrderLineServed: 'Mark item served',
  markOrderComp: 'Free / complaint',
  cancelOrder: 'Cancel order',
  createBillDraft: 'Create bill',
  setBillTip: 'Set tip',
};
